import { Draft, PayloadAction } from '@reduxjs/toolkit';
import { ILocationState }       from 'Redux/Slices/Location/LocationSlice';
import { Location }             from 'Domain/Models';
import { removeActionTypes }    from 'Utils/ReducerUtility';

export const updateLocationRequest = (state: Draft<ILocationState>, { type }: PayloadAction<{ id: string, formData: any }>) => {
  state.openRequests = [ ...state.openRequests, type ];
  state.failedRequests = removeActionTypes(state.failedRequests, type);
  state.lastUpdateId = null;
  state.updatedAt = Date.now();
};

export const updateLocationSuccess = (state: Draft<ILocationState>, { type, payload }: PayloadAction<{
  location: Location
}>) => {
  state.updatedAt = Date.now();
  state.openRequests = removeActionTypes(state.openRequests, type);
  state.lastUpdateId = payload.location.id;
  state.entries = { ...state.entries, [payload.location.id]: payload.location };
};

export const updateLocationFailure = (state: Draft<ILocationState>, { type }: PayloadAction<{ error: any }>) => {
  state.updatedAt = Date.now();
  state.failedRequests = [ ...state.failedRequests, type ];
  state.openRequests = removeActionTypes(state.openRequests, type);
};
